module.exports = __webpack_public_path__ + "img/level.96106f9d.svg";